import React from 'react';

import { Helpers } from '../../../core/src/helpers';
import Link from '../../../shared/components/hyperlink';
import DisclaimerTooltip from '../../../shared/components/disclaimer-tooltip';

export default ({ name, value, prodDoc, disclaimers }) => {
    let footnoteRegex = Helpers.footnoteRegex();
    const docArray =  prodDoc && (typeof prodDoc === 'string' ? [prodDoc] : prodDoc);
    const ankerExtractRegex = /<a href="(.*?)">([^<]+)<\/a>/;
    const ankerMatch = (str) => str.match(ankerExtractRegex);
    const linkRegex = /((https)|(http)):\/\/store.hp.com\/us\/en\/pdp\//;
    return (<div className='specs-row clearfix'>
            <div className='specs-cell spec-name'><h2 tabIndex={0} aria-label={name}>{name}</h2></div>
            <div className='specs-cell spec-values'>
                {
                    value && value.constructor === Array && value.map((val, i) => {
                        //if not a string just return the object (assumes it's React component)
                        if(typeof val === 'object'){
                            return val;
                        }
                        const match = ankerMatch(val)
                        if(match){
                            let [string, link, name] = match;
                            //if link goes to pdp, use app PDP
                            link = link.replace(linkRegex,"/pdp/").split('" target')[0];
                            return(<Link key={i} className='spec-value' to={link} newTab={ true }>{name}</Link>)
                        }
                        return(
                            <DisclaimerTooltip key={i} string={val} footnoteRegex={footnoteRegex} disclaimers={disclaimers}>
                                {(string, replaced) => {
                                    const htmlRegex = new RegExp('(<([^>]+)>)', 'gi');
                                    if ( typeof string === 'string' && htmlRegex.test(string) ) {
                                        const specValHtml = `${ ( i !== 0 && !replaced ) ? '<br/>' : '' }${ string }`;
                                        return (<div tabIndex={0} aria-label={string} className='spec-value' dangerouslySetInnerHTML={ Helpers.createMarkup(specValHtml) } />)
                                    } else {
                                        return (<div tabIndex={0} aria-label={string} className='spec-value'>{ i !== 0 && !replaced && <br/> }{ string }</div>);
                                    }
                                }}
                            </DisclaimerTooltip>
                        )
                    })
                }
                {
                    docArray && docArray.map((doc, i) => {
                        let [ name, link ] = doc.split("|");
                        //sometimes a doc name is not provided
                        link = link || name;
                        name = name !== link ? name : null;
                        return (<a arial-label={name} key={i} href={link} target="_blank" rel="noopener">{name || 'View Document'}<br/></a>)
                    })
                }
            </div>
        </div>)
}
